// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Start: Custom Navigation Links*/
/* Smooth Slide-Down Transition for Bootstrap Collapse */
.collapse {
  transition: height 0.4s ease-in-out;
  overflow: hidden;
}

.collapsing {
  height: 0 !important; /* Collapsing starts from height 0 */
  transition: height 0.4s ease-in-out;
  overflow: hidden;
}

.collapse.show {
  height: auto;
}

/* Navigation Links: Vertical Alignment */
.nav-borders {
  display: flex;
  flex-direction: column; /* Align links vertically */
  gap: 10px; /* Spacing between links */
  padding: 10px;
}

.nav-borders .nav-link {
  display: block;
  color: #333; /* Default text color */
  padding: 8px 12px;
  text-decoration: none;
  border-radius: 5px; /* Rounded corners */
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* Hover Effect */
.nav-borders .nav-link:hover {
  background-color: #007bff; /* Blue background on hover */
  color: #fff; /* White text */
}

.topnav-settings {
  position: relative;
}

.topnav-settings__toggle {
  border: 0;
  background: transparent;
}

.topnav-settings__menu {
  min-width: 14rem;
  padding: 0.5rem 0;
}

.topnav-settings__item {
  padding: 0.6rem 1rem;
  font-size: 0.95rem;
}

/* --------------------------------------------
   3) Only Show #navbarResponsive Styling
      at 1009px and Below
-------------------------------------------- */
@media (max-width: 1190px) {
  #navbarResponsive {
    background-color: #f8f9fa;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
  }
}
/* --------------------------------------------
   4) Custom .navbar-expand-custom Logic
      - Hide toggler above 1009px
      - Show toggler below 1010px
-------------------------------------------- */
/* Base .navbar-expand-custom class
   (no specific styling yet; just a placeholder) */
.navbar-expand-custom {
  /* Additional base styles if needed */
}

/* Show the collapsible menu as expanded above 1010px | 1119px */
@media (min-width: 1191px) {
  .navbar-expand-custom .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
    overflow: visible;
  }
  .navbar-expand-custom .navbar-toggler {
    display: none;
  }
  .nav-borders {
    overflow: visible;
  }
}
/* Use the collapsible (burger) below 1010px | 1118px*/
@media (max-width: 1190px) {
  .navbar-expand-custom .navbar-collapse {
    /* or rely on .collapse + .show classes */
  }
  .navbar-expand-custom .navbar-toggler {
    display: block;
  }
}
/* --------------------------------------------
   5) Misc. Positioning & Transition
-------------------------------------------- */
.topnav {
  height: 5.625rem;
}
.topnav .navbar-brand img {
  max-width: 10rem;
}

sbpro-top-nav-docs {
  display: contents;
}

.nav-custom-position {
  position: relative;
}
@media (min-width: 1191px) {
  .nav-custom-position {
    position: absolute;
    right: 0;
    flex-direction: row;
  }
}

.top-nav-actions {
  display: flex;
  align-items: center;
  gap: 22px;
}

.topnav-left,
.topnav-right {
  flex: 0 0 auto;
  min-width: 0;
}

.topnav-center {
  flex: 1 1 auto;
  min-width: 0;
  justify-content: center;
}

.topnav-api-key {
  display: flex;
  align-items: center;
}

.top-nav-action-btn,
.top-nav-action-btn.e-btn,
:host ::ng-deep .topnav .top-nav-action-btn,
:host ::ng-deep .topnav .top-nav-action-btn.e-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  min-width: 42px;
  height: 42px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: #7b8491;
  box-shadow: none;
  line-height: 1;
  transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;
}
.top-nav-action-btn:hover, .top-nav-action-btn:focus-visible,
.top-nav-action-btn.e-btn:hover,
.top-nav-action-btn.e-btn:focus-visible,
:host ::ng-deep .topnav .top-nav-action-btn:hover,
:host ::ng-deep .topnav .top-nav-action-btn:focus-visible,
:host ::ng-deep .topnav .top-nav-action-btn.e-btn:hover,
:host ::ng-deep .topnav .top-nav-action-btn.e-btn:focus-visible {
  border-color: #cfe3ff;
  background: #eef6ff;
  color: #0066ff;
  outline: none;
  box-shadow: none;
}

.top-nav-action-btn.active,
:host ::ng-deep .topnav .top-nav-action-btn.active {
  border: 1px solid #cfe3ff;
  background: #eef6ff;
  color: #0066ff;
}

.top-nav-svg-icon,
:host ::ng-deep .topnav .top-nav-svg-icon {
  width: 24px;
  height: 24px;
  display: block;
  object-fit: contain;
  opacity: 0.82;
  filter: grayscale(1) saturate(0) brightness(0) opacity(0.62);
}

.top-nav-action-btn:hover .top-nav-svg-icon,
.top-nav-action-btn:focus-visible .top-nav-svg-icon,
:host ::ng-deep .topnav .top-nav-action-btn:hover .top-nav-svg-icon,
:host ::ng-deep .topnav .top-nav-action-btn:focus-visible .top-nav-svg-icon {
  opacity: 1;
  filter: invert(34%) sepia(96%) saturate(2870%) hue-rotate(207deg) brightness(101%) contrast(104%);
}

.top-nav-action-icon,
.top-nav-action-btn .e-icons,
:host ::ng-deep .topnav .top-nav-action-icon,
:host ::ng-deep .topnav .top-nav-action-btn .e-icons {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: currentColor;
  font-size: 24px;
  line-height: 24px;
}

.top-nav-action-icon,
:host ::ng-deep .topnav .top-nav-action-icon {
  stroke: currentColor;
}

.api-key-drawer-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1040;
  background: rgba(15, 23, 42, 0.32);
}

.api-key-drawer {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1041;
  display: flex;
  flex-direction: column;
  width: min(28.75rem, 100vw);
  height: 100vh;
  padding: 1.5rem;
  border-left: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: -20px 0 48px rgba(15, 23, 42, 0.18);
  transform: translateX(100%);
  transition: transform 0.24s ease;
  pointer-events: none;
}

.api-key-drawer--open {
  transform: translateX(0);
  pointer-events: auto;
}

.api-key-drawer__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding-bottom: 1.25rem;
  border-bottom: 1px solid #e2e8f0;
}

.api-key-drawer__title {
  margin: 0;
  color: #0f172a;
  font-size: 1.15rem;
  font-weight: 700;
}

.api-key-drawer__description,
.api-key-drawer__helper {
  margin: 0.45rem 0 0;
  color: #64748b;
  font-size: 0.86rem;
  line-height: 1.45;
}

.api-key-drawer__close,
.api-key-drawer__edit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dbe3ec;
  background: #ffffff;
  color: #475569;
}
.api-key-drawer__close:hover, .api-key-drawer__close:focus-visible,
.api-key-drawer__edit:hover,
.api-key-drawer__edit:focus-visible {
  border-color: #b8c7d7;
  background: #f8fafc;
  color: #004d80;
  outline: none;
}

.api-key-drawer__close {
  width: 2rem;
  height: 2rem;
  border-radius: 0.55rem;
  font-size: 1.25rem;
  line-height: 1;
}

.api-key-drawer__content {
  padding-top: 1.5rem;
}

.api-key-drawer__section-title {
  margin: 0 0 1rem;
  color: #1e293b;
  font-size: 0.95rem;
  font-weight: 700;
}

.api-key-drawer__label {
  display: block;
  margin-bottom: 0.4rem;
  color: #334155;
  font-size: 0.82rem;
  font-weight: 700;
}

.api-key-drawer__input {
  width: 100%;
  height: 2.65rem;
  padding: 0 0.8rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.55rem;
  color: #0f172a;
  font-size: 0.92rem;
  outline: none;
}
.api-key-drawer__input:focus {
  border-color: #004d80;
  box-shadow: 0 0 0 3px rgba(0, 77, 128, 0.12);
}
.api-key-drawer__input[aria-invalid=true] {
  border-color: #dc2626;
}

.api-key-drawer__error {
  margin: 0.45rem 0 0;
  color: #dc2626;
  font-size: 0.78rem;
  font-weight: 600;
}

.api-key-drawer__summary {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.8rem;
  border: 1px solid #dbe3ec;
  border-radius: 0.7rem;
  background: #f8fafc;
}

.api-key-drawer__masked-key {
  flex: 1 1 auto;
  min-width: 0;
  color: #0f172a;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  font-size: 0.9rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.api-key-drawer__edit {
  flex: 0 0 auto;
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
}
.api-key-drawer__edit i-feather {
  width: 0.95rem;
  height: 0.95rem;
}

.api-key-drawer__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.5rem;
}

.api-key-drawer__button {
  min-width: 5rem;
  height: 2.35rem;
  padding: 0 1rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.55rem;
  background: #ffffff;
  color: #334155;
  font-size: 0.86rem;
  font-weight: 700;
}
.api-key-drawer__button:hover, .api-key-drawer__button:focus-visible {
  background: #f8fafc;
  outline: none;
}

.api-key-drawer__button--primary {
  border-color: #004d80;
  background: #004d80;
  color: #ffffff;
}
.api-key-drawer__button--primary:hover, .api-key-drawer__button--primary:focus-visible {
  background: #003f69;
}

@media (max-width: 1190px) {
  .navbar-collapse {
    transition: height 0.3s ease-out;
  }
}
/*Burger Menu Effects*/
.burger-menu {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 40px;
  height: 34px;
  background: transparent;
  border: 2px solid #000;
  cursor: pointer;
  padding: 5px;
  box-sizing: border-box;
  outline: none;
}
.burger-menu__line {
  display: block;
  width: 100%;
  height: 5px;
  background-color: #333;
  border-radius: 2px;
  transition: all 0.3s ease;
  position: relative;
  margin-bottom: 2px;
}
.burger-menu--open .burger-menu__line:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}
.burger-menu--open .burger-menu__line:nth-child(2) {
  opacity: 0;
}
.burger-menu--open .burger-menu__line:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}

/*END: Burger Menu Effects*/
@media (min-width: 1190px) {
  .topnav .navbar-brand {
    width: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/navigation/containers/top-nav/top-nav.component.scss"],"names":[],"mappings":"AAGA,kCAAA;AACA,wDAAA;AACA;EACI,mCAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,oBAAA,EAAA,oCAAA;EACA,mCAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,YAAA;AAFJ;;AAKA,yCAAA;AACA;EACI,aAAA;EACA,sBAAA,EAAA,2BAAA;EACA,SAAA,EAAA,0BAAA;EACA,aAAA;AAFJ;;AAKA;EACI,cAAA;EACA,WAAA,EAAA,uBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA,EAAA,oBAAA;EACA,uDAAA;AAFJ;;AAKA,iBAAA;AACA;EACI,yBAAA,EAAA,6BAAA;EACA,WAAA,EAAA,eAAA;AAFJ;;AAKA;EACI,kBAAA;AAFJ;;AAKA;EACI,SAAA;EACA,uBAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,oBAAA;EACA,kBAAA;AAFJ;;AAKA;;;8CAAA;AAIA;EACE;IACE,yBAAA;IACA,wCAAA;IACA,kBAAA;EAFF;AACF;AAKA;;;;8CAAA;AAMA;kDAAA;AAEA;EACE,qCAAA;AAJF;;AAOA,gEAAA;AACA;EACE;IACE,wBAAA;IACA,gBAAA;IACA,iBAAA;EAJF;EAOA;IACE,aAAA;EALF;EAQA;IACE,iBAAA;EANF;AACF;AASA,sDAAA;AACA;EACE;IACE,yCAAA;EAPF;EAUA;IACE,cAAA;EARF;AACF;AAWA;;8CAAA;AAGA;EACE,gBAAA;AATF;AAWQ;EACI,gBAAA;AATZ;;AAcA;EACE,iBAAA;AAXF;;AAcA;EACE,kBAAA;AAXF;AAaE;EAHF;IAII,kBAAA;IACA,QAAA;IACA,mBAAA;EAVF;AACF;;AAaA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAVJ;;AAaA;;EAEI,cAAA;EACA,YAAA;AAVJ;;AAaA;EACI,cAAA;EACA,YAAA;EACA,uBAAA;AAVJ;;AAaA;EACI,aAAA;EACA,mBAAA;AAVJ;;AAaA;;;;EAII,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,kFAAA;AAVJ;AAYI;;;;;;;EAEI,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;AALR;;AASA;;EAEI,yBAAA;EACA,mBAAA;EACA,cAAA;AANJ;;AASA;;EAEI,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,4DAAA;AANJ;;AASA;;;;EAII,UAAA;EACA,iGAAA;AANJ;;AASA;;;;EAII,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AANJ;;AASA;;EAEI,oBAAA;AANJ;;AASA;EACI,eAAA;EACA,QAAA;EACA,aAAA;EACA,kCAAA;AANJ;;AASA;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,+CAAA;EACA,2BAAA;EACA,gCAAA;EACA,oBAAA;AANJ;;AASA;EACI,wBAAA;EACA,oBAAA;AANJ;;AASA;EACI,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,gCAAA;AANJ;;AASA;EACI,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AANJ;;AASA;;EAEI,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AANJ;;AASA;;EAEI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AANJ;AAQI;;;EAEI,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;AALR;;AASA;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AANJ;;AASA;EACI,mBAAA;AANJ;;AASA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AANJ;;AASA;EACI,cAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AANJ;;AASA;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;AANJ;AAQI;EACI,qBAAA;EACA,4CAAA;AANR;AASI;EACI,qBAAA;AAPR;;AAWA;EACI,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AARJ;;AAWA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;AARJ;;AAWA;EACI,cAAA;EACA,YAAA;EACA,cAAA;EACA,gGAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AARJ;;AAWA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AARJ;AAUI;EACI,cAAA;EACA,eAAA;AARR;;AAYA;EACI,aAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;AATJ;;AAYA;EACI,eAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AATJ;AAWI;EAEI,mBAAA;EACA,aAAA;AAVR;;AAcA;EACI,qBAAA;EACA,mBAAA;EACA,cAAA;AAXJ;AAaI;EAEI,mBAAA;AAZR;;AAgBA;EACE;IACE,gCAAA;EAbF;AACF;AAgBA,sBAAA;AACA;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;AAdJ;AAgBI;EACI,cAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AAdR;AAiBI;EACI,4CAAA;AAfR;AAkBI;EACI,UAAA;AAhBR;AAmBI;EACI,8CAAA;AAjBR;;AAsBA,2BAAA;AAGA;EACI;IACI,WAAA;EArBN;AACF","sourcesContent":["@import 'styles/core/variables.scss';\n\n\n/* Start: Custom Navigation Links*/\n/* Smooth Slide-Down Transition for Bootstrap Collapse */\n.collapse {\n    transition: height 0.4s ease-in-out;\n    overflow: hidden;\n}\n\n.collapsing {\n    height: 0 !important; /* Collapsing starts from height 0 */\n    transition: height 0.4s ease-in-out;\n    overflow: hidden;\n}\n\n.collapse.show {\n    height: auto;\n}\n\n/* Navigation Links: Vertical Alignment */\n.nav-borders {\n    display: flex;\n    flex-direction: column; /* Align links vertically */\n    gap: 10px; /* Spacing between links */\n    padding: 10px;\n}\n\n.nav-borders .nav-link {\n    display: block;\n    color: #333; /* Default text color */\n    padding: 8px 12px;\n    text-decoration: none;\n    border-radius: 5px; /* Rounded corners */\n    transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n/* Hover Effect */\n.nav-borders .nav-link:hover {\n    background-color: #007bff; /* Blue background on hover */\n    color: #fff; /* White text */\n}\n\n.topnav-settings {\n    position: relative;\n}\n\n.topnav-settings__toggle {\n    border: 0;\n    background: transparent;\n}\n\n.topnav-settings__menu {\n    min-width: 14rem;\n    padding: 0.5rem 0;\n}\n\n.topnav-settings__item {\n    padding: 0.6rem 1rem;\n    font-size: 0.95rem;\n}\n\n/* --------------------------------------------\n   3) Only Show #navbarResponsive Styling\n      at 1009px and Below\n-------------------------------------------- */\n@media (max-width: 1190px) {\n  #navbarResponsive {\n    background-color: #f8f9fa;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    border-radius: 5px;\n  }\n}\n\n/* --------------------------------------------\n   4) Custom .navbar-expand-custom Logic\n      - Hide toggler above 1009px\n      - Show toggler below 1010px\n-------------------------------------------- */\n\n/* Base .navbar-expand-custom class\n   (no specific styling yet; just a placeholder) */\n.navbar-expand-custom {\n  /* Additional base styles if needed */\n}\n\n/* Show the collapsible menu as expanded above 1010px | 1119px */\n@media (min-width: 1191px) {\n  .navbar-expand-custom .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n    overflow: visible;\n  }\n\n  .navbar-expand-custom .navbar-toggler {\n    display: none;\n  }\n\n  .nav-borders {\n    overflow: visible;\n  }\n}\n\n/* Use the collapsible (burger) below 1010px | 1118px*/\n@media (max-width: 1190px) {\n  .navbar-expand-custom .navbar-collapse {\n    /* or rely on .collapse + .show classes */\n  }\n\n  .navbar-expand-custom .navbar-toggler {\n    display: block;\n  }\n}\n\n/* --------------------------------------------\n   5) Misc. Positioning & Transition\n-------------------------------------------- */\n.topnav {\n  height: 5.625rem; // 90px\n    .navbar-brand {\n        img {\n            max-width: 10rem;\n        }\n    }\n}\n\nsbpro-top-nav-docs {\n  display: contents;\n}\n\n.nav-custom-position {\n  position: relative;\n\n  @media (min-width: 1191px) {\n    position: absolute;\n    right: 0;\n    flex-direction: row;\n  }\n}\n\n.top-nav-actions {\n    display: flex;\n    align-items: center;\n    gap: 22px;\n}\n\n.topnav-left,\n.topnav-right {\n    flex: 0 0 auto;\n    min-width: 0;\n}\n\n.topnav-center {\n    flex: 1 1 auto;\n    min-width: 0;\n    justify-content: center;\n}\n\n.topnav-api-key {\n    display: flex;\n    align-items: center;\n}\n\n.top-nav-action-btn,\n.top-nav-action-btn.e-btn,\n:host ::ng-deep .topnav .top-nav-action-btn,\n:host ::ng-deep .topnav .top-nav-action-btn.e-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 42px;\n    min-width: 42px;\n    height: 42px;\n    padding: 0;\n    border: 0;\n    border-radius: 999px;\n    background: transparent;\n    color: #7b8491;\n    box-shadow: none;\n    line-height: 1;\n    transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;\n\n    &:hover,\n    &:focus-visible {\n        border-color: #cfe3ff;\n        background: #eef6ff;\n        color: #0066ff;\n        outline: none;\n        box-shadow: none;\n    }\n}\n\n.top-nav-action-btn.active,\n:host ::ng-deep .topnav .top-nav-action-btn.active {\n    border: 1px solid #cfe3ff;\n    background: #eef6ff;\n    color: #0066ff;\n}\n\n.top-nav-svg-icon,\n:host ::ng-deep .topnav .top-nav-svg-icon {\n    width: 24px;\n    height: 24px;\n    display: block;\n    object-fit: contain;\n    opacity: 0.82;\n    filter: grayscale(1) saturate(0) brightness(0) opacity(0.62);\n}\n\n.top-nav-action-btn:hover .top-nav-svg-icon,\n.top-nav-action-btn:focus-visible .top-nav-svg-icon,\n:host ::ng-deep .topnav .top-nav-action-btn:hover .top-nav-svg-icon,\n:host ::ng-deep .topnav .top-nav-action-btn:focus-visible .top-nav-svg-icon {\n    opacity: 1;\n    filter: invert(34%) sepia(96%) saturate(2870%) hue-rotate(207deg) brightness(101%) contrast(104%);\n}\n\n.top-nav-action-icon,\n.top-nav-action-btn .e-icons,\n:host ::ng-deep .topnav .top-nav-action-icon,\n:host ::ng-deep .topnav .top-nav-action-btn .e-icons {\n    width: 24px;\n    height: 24px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: currentColor;\n    font-size: 24px;\n    line-height: 24px;\n}\n\n.top-nav-action-icon,\n:host ::ng-deep .topnav .top-nav-action-icon {\n    stroke: currentColor;\n}\n\n.api-key-drawer-backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 1040;\n    background: rgba(15, 23, 42, 0.32);\n}\n\n.api-key-drawer {\n    position: fixed;\n    top: 0;\n    right: 0;\n    z-index: 1041;\n    display: flex;\n    flex-direction: column;\n    width: min(28.75rem, 100vw);\n    height: 100vh;\n    padding: 1.5rem;\n    border-left: 1px solid #e2e8f0;\n    background: #ffffff;\n    box-shadow: -20px 0 48px rgba(15, 23, 42, 0.18);\n    transform: translateX(100%);\n    transition: transform 0.24s ease;\n    pointer-events: none;\n}\n\n.api-key-drawer--open {\n    transform: translateX(0);\n    pointer-events: auto;\n}\n\n.api-key-drawer__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 1rem;\n    padding-bottom: 1.25rem;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.api-key-drawer__title {\n    margin: 0;\n    color: #0f172a;\n    font-size: 1.15rem;\n    font-weight: 700;\n}\n\n.api-key-drawer__description,\n.api-key-drawer__helper {\n    margin: 0.45rem 0 0;\n    color: #64748b;\n    font-size: 0.86rem;\n    line-height: 1.45;\n}\n\n.api-key-drawer__close,\n.api-key-drawer__edit {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid #dbe3ec;\n    background: #ffffff;\n    color: #475569;\n\n    &:hover,\n    &:focus-visible {\n        border-color: #b8c7d7;\n        background: #f8fafc;\n        color: #004d80;\n        outline: none;\n    }\n}\n\n.api-key-drawer__close {\n    width: 2rem;\n    height: 2rem;\n    border-radius: 0.55rem;\n    font-size: 1.25rem;\n    line-height: 1;\n}\n\n.api-key-drawer__content {\n    padding-top: 1.5rem;\n}\n\n.api-key-drawer__section-title {\n    margin: 0 0 1rem;\n    color: #1e293b;\n    font-size: 0.95rem;\n    font-weight: 700;\n}\n\n.api-key-drawer__label {\n    display: block;\n    margin-bottom: 0.4rem;\n    color: #334155;\n    font-size: 0.82rem;\n    font-weight: 700;\n}\n\n.api-key-drawer__input {\n    width: 100%;\n    height: 2.65rem;\n    padding: 0 0.8rem;\n    border: 1px solid #cbd5e1;\n    border-radius: 0.55rem;\n    color: #0f172a;\n    font-size: 0.92rem;\n    outline: none;\n\n    &:focus {\n        border-color: #004d80;\n        box-shadow: 0 0 0 3px rgba(0, 77, 128, 0.12);\n    }\n\n    &[aria-invalid='true'] {\n        border-color: #dc2626;\n    }\n}\n\n.api-key-drawer__error {\n    margin: 0.45rem 0 0;\n    color: #dc2626;\n    font-size: 0.78rem;\n    font-weight: 600;\n}\n\n.api-key-drawer__summary {\n    display: flex;\n    align-items: center;\n    gap: 0.65rem;\n    padding: 0.8rem;\n    border: 1px solid #dbe3ec;\n    border-radius: 0.7rem;\n    background: #f8fafc;\n}\n\n.api-key-drawer__masked-key {\n    flex: 1 1 auto;\n    min-width: 0;\n    color: #0f172a;\n    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', monospace;\n    font-size: 0.9rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.api-key-drawer__edit {\n    flex: 0 0 auto;\n    width: 2rem;\n    height: 2rem;\n    border-radius: 0.5rem;\n\n    i-feather {\n        width: 0.95rem;\n        height: 0.95rem;\n    }\n}\n\n.api-key-drawer__actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.75rem;\n    margin-top: 1.5rem;\n}\n\n.api-key-drawer__button {\n    min-width: 5rem;\n    height: 2.35rem;\n    padding: 0 1rem;\n    border: 1px solid #cbd5e1;\n    border-radius: 0.55rem;\n    background: #ffffff;\n    color: #334155;\n    font-size: 0.86rem;\n    font-weight: 700;\n\n    &:hover,\n    &:focus-visible {\n        background: #f8fafc;\n        outline: none;\n    }\n}\n\n.api-key-drawer__button--primary {\n    border-color: #004d80;\n    background: #004d80;\n    color: #ffffff;\n\n    &:hover,\n    &:focus-visible {\n        background: #003f69;\n    }\n}\n\n@media (max-width: 1190px) {\n  .navbar-collapse {\n    transition: height 0.3s ease-out;\n  }\n}\n\n/*Burger Menu Effects*/\n.burger-menu {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 40px;\n    height: 34px;\n    background: transparent;\n    border: 2px solid #000;\n    cursor: pointer;\n    padding: 5px;\n    box-sizing: border-box;\n    outline: none;\n\n    &__line {\n        display: block;\n        width: 100%;\n        height: 5px;\n        background-color: #333;\n        border-radius: 2px;\n        transition: all 0.3s ease;\n        position: relative;\n        margin-bottom: 2px;\n    }\n\n    &--open .burger-menu__line:nth-child(1) {\n        transform: rotate(45deg) translate(5px, 5px);\n    }\n\n    &--open .burger-menu__line:nth-child(2) {\n        opacity: 0;\n    }\n\n    &--open .burger-menu__line:nth-child(3) {\n        transform: rotate(-45deg) translate(5px, -5px);\n    }\n}\n\n\n/*END: Burger Menu Effects*/\n\n// Overwrtting the topnav navbar-brand | 992\n@media (min-width: 1190px) {\n    .topnav .navbar-brand {\n        width: auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
